import styled from 'styled-components'

import { IWrapper } from './globals.interfaces'

export const Wrapper = styled.div<IWrapper>`
  align-items: ${(props) => props.alignItems || 'start'};
  background-color: ${(props) => props.backgroundColor};
  background: ${(props) => props.background};
  border: ${(props) => props.border};
  border-bottom: ${(props) => props.borderBottom || props.borderY};
  border-left: ${(props) => props.borderLeft || props.borderX};
  border-radius: ${(props) => props.borderRadius};
  border-right: ${(props) => props.borderRight || props.borderX};
  border-top: ${(props) => props.borderTop || props.borderY};
  bottom: ${(props) => props.bottom};
  box-shadow: ${(props) => props.boxShadow};
  color: ${(props) => props.color};
  cursor: ${(props) => props.cursor};
  display: ${(props) => props.display || 'flex'};
  flex: ${(props) => props.flex};
  flex-direction: ${(props) => props.direction || 'row'};
  flex-wrap: ${(props) => props.wrap};
  gap: ${(props) => props.gap};
  grid-gap: ${(props) => props.gridGap};
  grid-template-columns: ${(props) => props.gridTemplateColumns};
  grid-template-rows: ${(props) => props.gridTemplateRows};
  justify-content: ${(props) => props.justifyContent || 'start'};
  align-content: ${(props) => props.alignContent || 'flex-start'};
  height: ${(props) => props.height || '100%'};
  justify-content: ${(props) => props.justifyContent || 'start'};
  left: ${(props) => props.left};
  margin: ${(props) => props.margin};
  margin-top: ${(props) => props.marginTop || props.marginY};
  margin-right: ${(props) => props.marginRight || props.marginX};
  margin-bottom: ${(props) => props.marginBottom || props.marginY};
  margin-left: ${(props) => props.marginLeft || props.marginX};
  min-height: ${(props) => props.height};
  min-width: ${(props) => props.minWidth};
  max-width: ${(props) => props.maxWidth};
  max-height: ${(props) => props.maxHeight};
  overflow: ${(props) => props.overflow};
  overflow-x: ${(props) => props.overflowX};
  overflow-y: ${(props) => props.overflowY};
  padding: ${(props) => props.padding};
  padding-top: ${(props) => props.paddingTop || props.paddingY};
  padding-right: ${(props) => props.paddingRight || props.paddingX};
  padding-bottom: ${(props) => props.paddingBottom || props.paddingY};
  padding-left: ${(props) => props.paddingLeft || props.paddingX};
  position: ${(props) => props.position};
  right: ${(props) => props.right};
  top: ${(props) => props.top};
  white-space: ${(props) => (props.fullWidthField ? 'nowrap' : 'normal')};
  width: ${(props) => props.width || '100%'};
  z-index: ${(props) => props.zIndex};
`
